module.exports = __webpack_public_path__ + "static/media/bh.4f041370.svg";